import { getTrem } from '@/api/assess'
import { message } from 'ant-design-vue';
import axios from 'axios'
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { nextTick } from 'vue'

import { getUserInfo, getUserById } from '@/api/user'

export const formatMinutes = (seconds) => {
    const totalMinutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (totalMinutes < 60) {
        return `${totalMinutes}分钟${remainingSeconds.toString().padStart(2, '0')}秒`;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}小时${minutes.toString().padStart(2, '0')}分钟${remainingSeconds.toString().padStart(2, '0')}秒`;
}

// 获取当前的学期
export const getTremData = async () => {
    let res = await getTrem()
    return res.data
}
// 下载评估报告
/**
 * 
 * @param {String} type 接口
 * @param {String} id  报告id
 * @param {String} typeTitle 报告标题
 * @param {String} name 学生名称
 */
export const downloadFileHeadler = async (type, id, typeTitle, name) => {
    const key = 'updatable'
    message.loading({ content: '报告下载中...', key });
    axios.get(`${type}${id}`, {
        responseType: 'blob', // 关键设置
        headers: {
            'authorization': `Bearer ${localStorage.getItem('token')}`
        }
    })
        .then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${typeTitle}_${name}_${Date.now()}.docx`;
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            message.success({ content: '报告下载成功', key, duration: 2 });
        })
        .catch(error => {
            console.error('Download failed:', error);
        });
};
// 打印评估报告
export const printEvealuateReport = async (dom) => {
    try {
        message.loading("正在准备打印内容...", 0);

        await nextTick();
        // 额外等待时间确保内容完全渲染
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // 获取要打印的内容区域
        const printContent = dom;
        if (!printContent) {
            message.error("获取打印内容失败");
            return;
        }

        // 使用 html2canvas 将内容转换为图片
        const canvas = await html2canvas(printContent, {
            scale: 2,
            useCORS: true,
            logging: false,
            allowTaint: true,
            backgroundColor: "#F4F5F9",
        });

        // 创建 PDF
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210; // A4 宽度
        const pageHeight = 297; // A4 高度
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // 添加图片到 PDF
        let heightLeft = imgHeight;
        let position = 0;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);

        pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // 如果内容超过一页，添加新页面
        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }

        // 打开打印预览
        pdf.autoPrint();
        window.open(pdf.output("bloburl"), "_blank");

        setTimeout(() => {
            message.destroy();
            // return false
        }, 500);
    } catch (error) {
        console.error("打印失败:", error);
        message.error(`打印失败：${error.message || "请稍后重试"}`);
    }
}
// 下载评估报告
export const downloadEvealuateReport = async (dom) => {
    try {
        message.loading("正在准备打印内容...", 0);

        await nextTick();
        // 额外等待时间确保内容完全渲染
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // 获取要打印的内容区域
        const printContent = dom;
        if (!printContent) {
            message.error("获取打印内容失败");
            return;
        }

        // 使用 html2canvas 将内容转换为图片
        const canvas = await html2canvas(printContent, {
            scale: 2,
            useCORS: true,
            logging: false,
            allowTaint: true,
            backgroundColor: "#F4F5F9",
        });

        // 创建 PDF
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 210; // A4 宽度
        const pageHeight = 297; // A4 高度
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        // 添加图片到 PDF
        let heightLeft = imgHeight;
        let position = 0;
        let pageData = canvas.toDataURL("image/jpeg", 1.0);

        pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        // 如果内容超过一页，添加新页面
        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
        }

        // 打开打印预览
        pdf.autoPrint();
        window.open(pdf.output("bloburl"), "_blank");

        setTimeout(() => {
            message.destroy();
            // return false
        }, 500);
    } catch (error) {
        console.error("打印失败:", error);
        message.error(`打印失败：${error.message || "请稍后重试"}`);
    }
}
export const autoWrap = (text, maxCharsPerLine) => {
    // 处理空文本
    if (!text) return '';

    // 如果是英文文本（包含空格）
    if (text.includes(' ')) {
        const words = text.split(' ');
        let lines = [];
        let currentLine = words[0];

        for (let i = 1; i < words.length; i++) {
            if (currentLine.length + words[i].length + 1 <= maxCharsPerLine) {
                currentLine += ' ' + words[i];
            } else {
                lines.push(currentLine);
                currentLine = words[i];
            }
        }
        lines.push(currentLine);
        return lines.join('\n');
    }
    // 处理中文文本（无空格）
    else {
        let lines = [];

        // 按字符数分割
        for (let i = 0; i < text.length; i += maxCharsPerLine) {
            lines.push(text.substring(i, i + maxCharsPerLine));
        }

        return lines.join('\n');
    }
}
// 辅助函数：提取月数
export const extractMonthsFromAge = (ageStr) => {
    if (!ageStr) return null
    const match = ageStr.split('个月')
    return match ? parseInt(match[0], 10) : null
}


// 获取视口的宽度，对应rem值
export const setRemUnit = () => {
    const docEl = document.documentElement
    const screenWidth = docEl.clientWidth || window.innerWidth
    if (screenWidth < 1500) {
        const rem = screenWidth / 100
        docEl.style.fontSize = rem + 'px'
        return docEl.style.fontSize
    } else if (screenWidth > 1500 && screenWidth <= 1920) {
        const rem = screenWidth / 110
        docEl.style.fontSize = rem + 'px'
        return docEl.style.fontSize
    } else if (screenWidth > 1921) {
        const rem = screenWidth / 130
        docEl.style.fontSize = rem + 'px'
        return docEl.style.fontSize
    }

}

// 重置json数据
export const resetJson = (jsonData) => {
    jsonData.forEach(item => {
        item.checkoutFlag = 0
    })
}

export const getUserData = async () => {
    try {
        const res = await getUserInfo()

        const resUser = await getUserById(res.data.userId)

        if (res.code === 200 && resUser.code === 200) {

            let title = ''
            // 角色IEP
            if (resUser.data.userType == 19) {
                title = '特殊儿童IEP智能决策系统'
            } else if (resUser.data.userType == 20) {
                title = '资源教室智能体评估平台'
            } else if (resUser.data.userType == 21) {
                title = '孤独症谱系智能干预评估训练系统'
            } else if (resUser.data.userType == 22) {
                title = '特殊儿童课程专项评估训练系统'
            } else if (resUser.data.userType == 23) {
                title = '特殊儿童送教上门多维评估与专项训练系统'
            } else if (resUser.data.userType == 24) {
                title = '特殊儿童心理发展评估与神经适应系统'
            } else if (resUser.data.userType == 25) {
                title = '特殊儿童神经肌肉评估训练系统'
            } else if (resUser.data.userType == 26) {
                title = '特殊儿童语言脑功能与整合干预系统'
            } else {
                title = '特教综合康复管理云平台'
            }

            localStorage.setItem("title", title);
            if (!res.data) {
                message.error('获取的用户信息为空')
                return
            }
            localStorage.setItem('userInfo', JSON.stringify(res.data))
            localStorage.setItem("role", res.data.userType);
        } else {
            message.error(res.message || '获取用户信息失败')
        }
    } catch (error) {
        message.error(`请求失败：${error.message}`)
    }
}


// 
export const calculateMonths = (birthDate) => {
    // 输入验证
    const birth = new Date(birthDate);
    if (isNaN(birth.getTime())) {
        return '无效的出生日期';
    }

    const today = new Date();
    if (birth > today) {
        return '出生日期不能晚于今天';
    }

    // 计算整数月
    let months = (today.getFullYear() - birth.getFullYear()) * 12;
    months += today.getMonth() - birth.getMonth();

    if (today.getDate() < birth.getDate()) {
        months--;
    }

    // 计算剩余天数
    const tempDate = new Date(birth);
    tempDate.setMonth(birth.getMonth() + months);

    let age = 0
    if (months > 12) {
        let years = Math.floor(months / 12);  // 2
        let remainingMonths = months % 12;     // 11
        age = years + '岁' + remainingMonths + '个月';
    }
    return {
        monthsAndDays: `${months}个月`,
        age: age
    };
}

// // 使用示例
// const result = calculateMonths('2023-05-15');
// console.log(result.totalMonths);        // 整数月数
// console.log(result.monthsAndDays);      // "X个月Y天"
// console.log(result.description);        // "X个月零Y天"